'use client'

import { memo, useMemo } from 'react'
import clsx from 'clsx'

import { SeoListName } from 'shared/analytics'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import { CartPorts } from '../../../ports'
import { CartItem, CategoryAccTypesWithProductCount } from '../../../types'
import { getCategoriesWithProductCount,sortCartItemsByCategory  } from '../utils'

import CartCategoryItemsList from './CartCategoryItemsList'

import styles from './CartItemsList.module.scss'

interface CartProductListProps extends React.HTMLAttributes<HTMLDivElement> {
  items: CartItem[]
  seoButtonPlace: string
  isModal?: boolean
  isCartEditMode?: boolean
  listName: SeoListName
  ports: CartPorts
}

const EmptyCart = memo(() => (
  <div className={styles.cartEmptyState}>Twój koszyk jest pusty</div>
))

const CartItemsList = ({
  items,
  seoButtonPlace,
  isModal,
  isCartEditMode,
  listName,
  ports,
  className,
  ...props
}: CartProductListProps) => {
  const itemsByCategory = useMemo(
    () => getCategoriesWithProductCount(sortCartItemsByCategory(items)),
    [items]
  )

  return (
    <div
      className={clsx(
        styles.wrapper,
        { [styles.wrapperModal]: isModal },
        className
      )}
      {...props}
    >
      <div className={styles.tabletContent}>
        <ports.EditSaleOrderNotice pageType='cart' variant='banner' />
      </div>
      {isNotNilOrEmpty(items) ? (
        <>
          {itemsByCategory?.map(
            (category: CategoryAccTypesWithProductCount, catIndex: number) => (
              <CartCategoryItemsList
                key={`${category.categoryId}-${catIndex}`}
                category={category}
                seoButtonPlace={seoButtonPlace}
                listName={listName}
              />
            )
          )}
        </>
      ) : (
        <EmptyCart />
      )}
    </div>
  )
}

export default memo(CartItemsList)
